export const CHANGE_PHOTO_INITIALIZE = 'PAGE_CHANGE_PHOTO_INITIALIZE';
export const CHANGE_PHOTO_ADD_PHOTO = 'PAGE_CHANGE_PHOTO_ADD_PHOTO';
export const CHANGE_PHOTO_CHANGE_ERROR = 'PAGE_CHANGE_PHOTO_CHANGE_ERROR';

export function initialize() {
  return {
    type: CHANGE_PHOTO_INITIALIZE
  };
}

export function changePhoto(photo) {
  return {
    type: CHANGE_PHOTO_ADD_PHOTO,
    photo
  };
}

export function changeError(errorMessage) {
  return {
    type: CHANGE_PHOTO_CHANGE_ERROR,
    errorMessage
  };
}



// WEBPACK FOOTER //
// ./js/actions/page/profile/ChangePhoto.js